import React from "react";
import { Box, Grid } from "@mui/material";
import { usePhoneMode } from "../../hooks";

export default function PageTitle({ title }) {
    const { isMobile } = usePhoneMode();
    return (
        <Box component="main" sx={{ p: !isMobile ? 3 : 1, width: '100%' }}>
            <Grid container>
                <Grid item xs={12} style={{ borderBottom: '1px solid #777', paddingBottom: !isMobile ? '12px' : '6px' }}>
                    <div style={{ color: '#43402f', fontSize: !isMobile ? '34px' : '24px', lineHeight: !isMobile ? '44px' : '34px', fontWeight: 400, textTransform: 'uppercase' }}>
                        {title}
                    </div>
                </Grid>
            </Grid>
        </Box >
    );
}